import store from '../store'

export default function (to, from, next) {
    let user = JSON.parse(window.localStorage.getItem("user"));
    if(user){
        store.commit('setUser', user);
        next()
    } else {
        next('/login/?loginError=true')
    }
}
